import SVGIconBase from './SVGIconBase';
import { jsx as _jsx } from "react/jsx-runtime";
const PartnerIcon = props => /*#__PURE__*/_jsx(SVGIconBase, Object.assign({
  "data-test-id": "vertical-nav-icon__partner"
}, props, {
  children: /*#__PURE__*/_jsx("path", {
    d: "m16.24,4h0,0m-.25.14l10.17,5.93v11.91l-10.17,5.93-10.17-5.93v-11.91l10.17-5.93m0-2.11c-.27,0-.54.07-.78.21l-10.66,6.22c-.47.28-.77.79-.77,1.33v12.47c0,.55.29,1.06.77,1.33l10.66,6.22c.24.14.51.21.78.21s.54-.07.78-.21l10.66-6.22c.47-.28.77-.79.77-1.33v-12.47c0-.55-.29-1.06-.77-1.33l-10.66-6.22c-.24-.14-.51-.21-.78-.21h0Zm-.21,20.25h0c-.28,0-.55-.12-.74-.33l-4.8-5.37c-.34-.38-.34-.96,0-1.34l4.68-5.13c.19-.21.45-.32.73-.33.29-.04.54.11.74.31l4.91,5.22c.36.38.36.97.01,1.36l-4.8,5.28c-.19.21-.46.33-.74.33Zm-3.45-6.36l3.46,3.87,3.43-3.78-3.54-3.76-3.35,3.67Z"
  })
}));
export default PartnerIcon;